"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormData = exports.prepare = exports.setToken = exports.getToken = exports.save = exports.read = exports.getStorageName = exports.getBaseUrl = exports.setStorageName = exports.setBaseUrl = exports.storageName = exports.baseUrl = void 0;
const qs_1 = require("qs");
exports.baseUrl = "";
exports.storageName = "jwt";
const setBaseUrl = (url) => void (exports.baseUrl = url);
exports.setBaseUrl = setBaseUrl;
const setStorageName = (key) => void (exports.storageName = key);
exports.setStorageName = setStorageName;
const getBaseUrl = () => exports.baseUrl;
exports.getBaseUrl = getBaseUrl;
const getStorageName = () => exports.storageName;
exports.getStorageName = getStorageName;
const read = () => {
    const jwt = localStorage.getItem(exports.storageName);
    return jwt && jwt !== "null" && jwt !== "undefined" ? JSON.parse(jwt) : null;
};
exports.read = read;
const save = (jwt) => {
    const json = JSON.stringify(jwt);
    localStorage.setItem((0, exports.getStorageName)(), json);
};
exports.save = save;
const getToken = () => (0, exports.read)();
exports.getToken = getToken;
const setToken = (jwt) => (0, exports.save)(jwt);
exports.setToken = setToken;
const prepare = (props) => {
    const { fetch, getAuthToken } = props;
    return async (props) => {
        var _a;
        const { url, method = "GET", data = {}, signal, headers: customHeaders = {} } = props;
        const token = getAuthToken();
        const hasData = method === "POST" || method === "PUT" || method === "PATCH";
        const headers = new Headers();
        headers.append("Accept", "application/json");
        if (token) {
            headers.append("Authorization", `Bearer ${token}`);
        }
        Object.entries(customHeaders).forEach(([key, value]) => {
            headers.append(key, value);
        });
        let queryString = "";
        if (!(data instanceof FormData)) {
            if (hasData) {
                headers.append("Content-Type", "application/json; charset=utf-8");
            }
            else {
                const serializedQuery = (0, qs_1.stringify)(data);
                queryString = serializedQuery ? `?${serializedQuery}` : "";
            }
        }
        const requestUrl = `${(0, exports.getBaseUrl)() || ""}${url}${queryString}`;
        const fallbackOrigin = typeof window !== "undefined" && ((_a = window.location) === null || _a === void 0 ? void 0 : _a.origin) ? window.location.origin : "http://localhost";
        const newUrl = new URL(requestUrl, fallbackOrigin);
        return fetch(newUrl.toString(), {
            signal,
            headers,
            credentials: "include",
            mode: "cors",
            method,
            body: hasData ? (data instanceof FormData ? data : JSON.stringify(data)) : void 0,
        });
    };
};
exports.prepare = prepare;
const getFormData = (object) => {
    const formData = new FormData();
    Object.keys(object).forEach(key => formData.append(key, object[key], object[key].name));
    return formData;
};
exports.getFormData = getFormData;
//# sourceMappingURL=utils.js.map